module.exports = __webpack_public_path__ + "media/images/fullscreen/root_login-d75c020347c5e8b83718f6e5692e5a85.png";